import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import qs from "qs";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import CustomInput from "../../components/CustomInput/CustomInput";
import Button from "@material-ui/core/Button";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CommonModel from "../Common/Model/CommonModel";
import { hist } from "../../index";
import loginPageStyle from "../../assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { forgotPassword, setPassword } from "../../actions/admin_action";
import toastr from "toastr";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";

toastr.options = {
  closeButton: true,
};

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      cardAnimaton: "cardHidden",
      show: false,
      msg: "",
      setPass: false,
      showNewPassword: false,
      newPass: "",
    };
  }

  componentDidMount() {
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  changeData = (event) => {
    let { id, value } = event.target;
    this.setState({
      [id]: value,
    });
  };
  changePass = (e) => {
    this.setState({
      newPass: e && e.target && e.target.value,
    });
  };
  setPassApi = () => {
    let { newPass } = this.state;
    let url = "https://berpayphase2dev.affleprojects.com/";
    const parsedString = qs.parse(window.location.href);
    const token =
      (parsedString &&
        parsedString[`${url}/admin/pages/resetPassword?token`]) ||
      "";
    //console.log("ppppp",token,window.location.href)
    let type = parsedString && parsedString["userType"];

    let obj = {
      password: newPass,
      token: token,
    };
    if (!newPass) {
      toastr.error(`Enter password`);
    } else {
      this.props.setPassword(obj, type);
    }
  };

  _handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (this.state.setPass) {
        this.setPassApi;
      } else this.forgot();
    }
  };

  forgot = async () => {
    let { email } = this.state;
    if (email === "") {
      toastr.error(`Email ID is required!`);
      return true;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      toastr.error(`Please enter a valid email.!`);
      return true;
    }
    let obj = {
      emailId: email,
    };
    setTimeout(() => {
      this.setState({
        setPass: true,
      });
    }, 2000);

    this.props.forgotPassword(obj);
  };

  goToLogin = () => {
    hist.push("/admin/pages/login-page");
  };

  handleClickShowNewPassword = () => {
    this.setState({
      showNewPassword: !this.state.showNewPassword,
    });
  };

  render() {
    const { classes } = this.props;
    const { setPass, showNewPassword, newPass } = this.state;
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <Card login className={classes[this.state.cardAnimaton]}>
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                color="primary"
              >
                <h4 className={classes.cardTitle}>Set Password</h4>
              </CardHeader>
              <CardBody style={{ textAlign: "center" }}>
                <CustomInput
                  labelText="Enter Password"
                  id="email"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  type={showNewPassword ? "text" : "password"}
                  value={newPass}
                  onChange={this.changePass}
                  required={true}
                  onKeyPress={this._handleKeyPress}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowNewPassword}
                        >
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </CardBody>
              :
              <div style={{ textAlign: "center", margin: "10px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.setPassApi}
                  style={{ width: "50%" }}
                >
                  Submit
                </Button>
              </div>
              <div style={{ textAlign: "center", margin: "10px" }}>
                <Button
                  color="primary"
                  onClick={this.goToLogin}
                  style={{ width: "50%" }}
                >
                  Login
                </Button>
              </div>
            </Card>
          </GridItem>
        </GridContainer>
        <CommonModel show={this.state.show} path="/" msg={this.state.msg} />
      </div>
    );
  }
}

// ForgetPage.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

const mapStateToProps = (state) => {
  return {
    // loginError: state.admin.loginError
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (obj) => dispatch(forgotPassword(obj)),
    setPassword: (obj, type) => dispatch(setPassword(obj, type)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(loginPageStyle)(ChangePassword));
